const events = {
  creatEvent: {
    stepOne: "Basic Info & PMs",
    verificationMethod: "Check-In Verification Method",
    stepTwo: "Roles & Shifts",
    stepThree: "Zones & Requirements",
    basicInfo: "Basic Info",
    projectManagers: "Project Managers",
    client: "Client",
    roles: "Roles",
    zones: "Zones",
    requirements: "Requirements",
    comments: "Comments",
    agreementFile: "Agreement file",
    projectManager: "Project Manager",
    role: "Role",
    zone: "Zone",
    addShift: "Add Shifts",
    requirement: "Requirement",
    publishModalConfirmMessage:
      "Kindly note that upon publishing the event, it will be displayed on the App upcoming events",
    publishPrivateConfirmMsg:
      "Kindly note that it’s a private event, applicants should be invited by the admins!",
    confirm: "Confirm",
    cancel: "Cancel",
    saveAsDraft: "Save As Draft",
    discardChanges: "Discard Changes",
    nextStep: "Next Step: {step}",
    finishAndPublishEvent: "Finish & Publish Event",
    /** Last step when the event is already published (edit upcoming/ongoing, etc.) — no publish action */
    finishEvent: "Finish",
    publishEventModal: {
      title: "Publish Event?",
      messageStart: "Your event is ready to go! Once published, it will become",
      messageHighlight: "public and visible",
      messageEnd: "on the app upcoming events",
      publishButton: "Publish Event",
      eventFallbackName: "Event Summary",
      staffRequested: "{count} Staff Requested",
    },
    superAdminCreate: {
      modalTitle: "Create Event",
      modalSubtitle: "Select Client Company",
      modalDescription:
        "Select the company this event will be created for before starting the event wizard.",
      companyFieldLabel: "Select Target Company",
      companyFieldPlaceholder: "Search by company name or ID",
      registeredCompanies: "{count} registered companies",
      warningTitle: "Company context",
      warningMessage:
        "Creating an event as a Super Admin will associate it with the selected company. All company-specific rules and e-wallet balances will apply.",
      companyRequiredError: "Select a company before creating the event",
      cancel: "Cancel",
      next: "Next: Basic Info",
    },
    basicInformation: {
      pageTitle: "Step 1: Basic Information",
      pageSubtitle: "Provide the core details to set up your event profile.",
      eventIdentity: "Event Identity",
      eventTimeline: "Event Timeline",
      managementClient: "Management & Client",
      verification: "Verification",
      managementVerification: "Management & Verification",
      eventName: "Event Name",
      eventNamePlaceholder: "Enter event name",
      eventType: "Event Type",
      eventTypePlaceholder: "Select event type",
      locationName: "Location",
      locationNamePlaceholder: "Enter location name",
      eventBrief: "Event Brief",
      eventBriefPlaceholder: "Describe the event objectives and background...",
      uploadLogo: "Upload Logo",
      logoUploading: "Uploading image",
      recurrence: "Recurrence",
      recurrenceAutoMonthlyHint:
        "Because this event lasts more than 7 days, recurrence was automatically changed from Daily to Monthly.",
      recurrenceDailyBlockedLongEvent:
        "Daily recurrence is not available when the event lasts more than 7 days.",
      daily: "Daily",
      monthly: "Monthly",
      singleDayEvent: "Single-day event",
      numberOfDays: "Number of Days",
      paidDaysOff: "Paid Days Off",
      numberOfDaysPlaceholder: "Enter number of days",
      paidDaysOffPlaceholder: "Enter paid days off",
      entertainment: "Entertainment",
      sports: "Sports",
      conference: "Conference",
      buildUp: "Build-up",
      actualEvent: "Actual Event",
      dismantling: "Dismantling",
      start: "Start",
      end: "End",
      startPlaceholder: "mm/dd/yyyy, --:-- --",
      endPlaceholder: "mm/dd/yyyy, --:-- --",
      checkInMethod: "Check-in Verification Method",
      basicVerification: "Basic Verification",
      supervisorApproval: "Supervisor Approval",
      organizerScanning: "Organizer QR Scanning",
      supervisorScanning: "Supervisor QR Scanning",
      projectManagers: "Event Project Managers",
      addPm: "Add PM",
      assign: "Assign",
      assignMore: "Assign More",
      addProjectManagerTitle: "Add Project Manager",
      addProjectManagerSubtitle: "Assign Staff To Management",
      managerName: "Manager Name",
      managerNamePlaceholder: "Manager Name",
      managerSearchPlaceholder: "Search by name or email...",
      managerHelper: "Only verified staff can be assigned as Project Managers.",
      removeProjectManager: "Remove project manager",
      projectManagersLoadError:
        "Could not load employees for project manager assignment.",
      projectManagersCompanyRequired:
        "Select the event company before assigning project managers.",
      responsibility: "Responsibility",
      responsibilityPlaceholder:
        "e.g. Lead Operations, Site Security, Guest Relations...",
      cancel: "Cancel",
      confirmAddManager: "Confirm",
      addManager: "Add Manager",
      clientName: "Client Name",
      clientNamePlaceholder: "Select or enter client name",
      location: "Location",
      eventLocation: "Event Location",
      emptyAddress: "Select location on map",
      locationBoundaries: "Location Boundaries",
      boundariesPlaceholder: "1000",
      radiusFromCenter: "Radius from center point",
      locationAndBoundaries: "Location & Boundaries",
      city: "City",
      cityPlaceholder: "Select city",
      cityChangedVerifyAddress:
        "You changed the city — make sure the location address still matches it.",
      errors: {
        logo: "Event logo is required",
        eventName: "Event name is required",
        eventType: "Event type is required",
        locationName: "Location name is required",
        city: "City is required",
        eventBrief: "Event brief is required",
        locationInvalid:
          "Please select a valid location from the map or enter a valid address.",
        boundaries: "Boundaries are required",
        boundariesPositive: "Boundaries must be a positive number",
        actualStart: "Actual event start is required",
        actualEnd: "Actual event end is required",
        endAfterStart: "End must be after start",
        buildUpPair: "Build-up start and end are required together",
        dismantlingPair: "Dismantling start and end are required together",
        checkInMethod: "Check-in verification method is required",
        projectManagers: "Assign at least one project manager",
        responsibilityRequired: "Responsibility is required",
        clientName: "Client name is required",
        numberOfDays: "Number of days is required",
        numberOfDaysMin: "Number of days must be at least 1",
        paidDaysOff: "Paid days off is required",
        paidDaysOffMin: "Paid days off cannot be negative",
        paidDaysOffMaxDays:
          "Paid days off must be less than or equal to Number of Days",
      },
    },
    defineRolesAndShifts: {
      pageTitle: "Roles & Shifts",
      pageSubtitle:
        "Structure the staffing requirements and compensation for each role.",
      addAnotherRole: "Add Another Role",
      rolesNavigation: "Roles Navigation",
      emptyTitle: "No roles defined yet",
      emptyDescription:
        "Create your first role to begin specifying staffing requirements, working shifts, and payroll details.",
      emptyNote:
        "Roles define the responsibilities and capacity of your event staff",
      addFirstRole: "Add First Role",
      addRole: "Add Role",
      roleFallback: "Role",
      roleName: "Role Name",
      roleNamePlaceholder: "e.g. Supervisor",
      numberOfMales: "Num. of Males",
      numberOfFemales: "Num. of Females",
      numberOfMalesPlaceholder: "Enter Num. of Males",
      numberOfFemalesPlaceholder: "Enter Num. of Females",
      uniformCode: "Uniform Code",
      uniformCodePlaceholder: "e.g. BLU-ORG-01",
      capacity: "Capacity",
      shiftCount: "{count} shift(s)",
      staffCount: "{count} staff",
      removeRole: "Remove Role",
      removeRoleMessage: "Are you sure you want to delete this role?",
      removeRoleHasApplicants:
        "This role cannot be removed because it has assigned applicants.",
      removeRoleWithinLaunchWindowMessage:
        "Event role cannot be deleted within 2 hours of launch, or while the event is ongoing or past",
      roleRemoved: "Role removed successfully",
      roleRemovalPendingSave: "Role marked for removal. Save changes to apply it.",
      remove: "Remove",
      cancel: "Cancel",
      confirmRemoval: "Confirm Removal",
      shiftRemoved: "Shift removed successfully",
      shiftConfiguration: "Shift Configuration",
      shiftLabel: "Shift {number}",
      addShift: "Add Shift",
      removeShift: "Remove Shift",
      removeShiftMessage: "Are you sure you want to remove this shift?",
      shiftSlot: "Shift Slot",
      shiftSlotPlaceholder: "Select shift slot",
      payrollAmount: "Payroll Amount (total)",
      payrollPerDay: "Payroll Per Day (auto)",
      shiftTiming: "Shift Timing",
      startTime: "Start Time",
      endTime: "End Time",
      checkInMargin: "Check-in Time Margin",
      checkOutMargin: "Check-out Time Margin",
      beforeWorkingStarts: "Before Working Time Starts (minutes)",
      afterWorkingStarts: "After Working Time Starts (minutes)",
      beforeWorkingEnds: "Before Working Time Ends (minutes)",
      afterWorkingEnds: "After Working Time Ends (minutes)",
      paidTraining: "Paid Training Session",
      paidTrainingDescription: "Enable to include mandatory paid preparation",
      duplicateTrainingTitle: "Duplicate Training from another shift?",
      duplicateTrainingDescription:
        "Quickly copy all training details from an existing shift.",
      duplicateTrainingFrom: "Duplicate from:",
      trainingName: "Training Name",
      trainingLocation: "Training Location",
      trainingPayroll: "Training Payroll",
      trainingDescription: "Training Description",
      trainingPaidAmountSar: "Paid Amount (SAR)",
      trainingNumberOfDays: "Number Of Training Days",
      trainingTimeline: "Training timing",
      trainingStart: "Training Start Time",
      trainingEnd: "Training End Time",
      trainingCheckInMargin: "Training Check-in Time Margin",
      trainingCheckOutMargin: "Training Check-out Time Margin",
      beforeTrainingStarts: "Before Training Starts (minutes)",
      afterTrainingStarts: "After Training Starts (minutes)",
      beforeTrainingEnds: "Before Training Ends (minutes)",
      afterTrainingEnds: "After Training Ends (minutes)",
    },
    zonesAndLogisticalRequirements: {
      pageTitle: "Zones & Logistical Requirements",
      pageSubtitle:
        "Finalize the operational locations and material needs for your event.",
      zoneManagement: "Zone Management",
      addNewZone: "Add New Zone",
      addAnotherZone: "Add Another Zone",
      zoneLabel: "Zone {number}",
      removeZone: "Remove Zone",
      removeZoneMessage: "Are you sure you want to delete this zone?",
      zoneRemoved: "Zone removed successfully",
      zoneRemovalPendingSave: "Zone marked for removal. Save changes to apply it.",
      zoneHasOrganizersTooltip:
        "Zone can not be deleted after assigning a Supervisor to it",
      zoneName: "Zone Name",
      zoneNamePlaceholder: "e.g. Main Entrance",
      supervisorName: "Supervisor Name",
      supervisorNamePlaceholder: "Enter supervisor name",
      managerInformation: "Manager Information",
      zoneManager: "Zone Manager",
      zoneManagerPlaceholder: "Select zone manager",
      managerEmail: "Manager Email",
      managerEmailPlaceholder: "manager@proline.sa",
      managerPhone: "Manager Phone",
      managerPhonePlaceholder: "+966 000 000 000",
      logisticalRequirements: "Logistical Requirements",
      addItem: "Add Item",
      requirementName: "Requirement Name",
      requirementNamePlaceholder: "Enter Requirement name",
      quantity: "Quantity",
      explanationNotes: "Explanation / Notes",
      explanationNotesPlaceholder: "Enter Requirement Explanation",
      addNewRequirements: "Add New Requirements",
      removeRequirement: "Remove Requirement",
      removeRequirementMessage:
        "Are you sure you want to delete this requirement?",
      requirementRemoved: "Requirement removed successfully",
      requirementRemovedSaveToApply:
        "Requirement removed. Save the event to apply this change.",
      zoneRequired: "Add at least one zone",
      requirementRequired: "Add at least one requirement",
      requirementsCatalogEmpty:
        "Requirements list could not be loaded. Refresh the page or try again later.",
      zoneMap: "Zone Map",
      zoneMapUploadText: "Click to upload or drag and drop Zone layout map Image",
      zoneMapFormatsHint: "PNG, JPG or PDF",
      zoneMapUploading: "Uploading file",
      zoneMapInvalidType: "Use PNG, JPG, or PDF only",
      zoneMapInvalidSize: "Maximum file size is 10MB",
    },
    labels: {
      uploadLabel: "Upload Image",
      eventImage: "Event Image",
      eventName: "Event Name",
      eventBrief: "Event Brief",
      eventLocation: "Event Location",
      organizerScanning: "Organizer QR Scanning",
      supervisorScanning: "Supervisor QR Scanning",
      supervisorApproval: "Supervisor Approval",
      basicVerification: "Basic Verification",
      diameter: "Location Boundaries (in meters)",
      eventType: "Event Type",
      publishingMode: "Publishing Mode",
      startBuildUpStart: "Buildup Start Date & Time",
      startBuildUpEnd: "Buildup End Date & Time",
      eventDayStart: "Event Start Date & Time",
      eventDayEnd: "Event End Date & Time",
      dismantlingDayStart: "Dismantling Start Date & Time",
      dismantlingDayEnd: "Dismantling End Date & Time",
      pmName: "Name",
      pmPhone: "Phone Number",
      responsibility: "Responsibility",
      nameOfRole: "Name",
      numberOfMales: "Number of Males",
      numberOfFemales: "Number of Females",
      numberOfShifts: "Number of Shifts",
      payrollAmount: "Payroll Amount",
      workingHours: "Working Time Slots",
      workingShifts: "Working Shifts",
      shiftType: "Shift Type",
      shiftMorning: "Morning",
      shiftEvening: "Evening",
      shiftNight: "Night",
      shiftFullTime: "Full Time",
      uniformCode: "Uniform Code",
      timeToArriveToTheSite: "Time to Arrive to The Site",
      zoneName: "Zone Name",
      zoneManager: "Manager",
      managerName: "Manager Name",
      zoneManagerLabel: "Zone Manager",
      email: "Manager Email",
      mobileNumber: "Manager Phone",
      supervisorName: "Supervisor Name",
      supervisorInfo: "Supervisor Info",
      managerInfo: "Manager Info",
      zonesMap: "Zones Map",
      nameOfRequirement: "Name",
      quantity: "Quantity",
      explanation: "Explanation",
      uploadFile: "Upload file",
      checkInTimeMargin: "Check-In Time Margin",
      checkOutTimeMargin: "Check-Out Time Margin",
      checkinStart: "Before working time starts (minutes)",
      checkinEnd: "After working time starts (minutes)",
      checkoutStart: "Before working time ends (minutes)",
      checkoutEnd: "After working time ends (minutes)",
      numberOfDays: "Number of Days",
      paidDaysOff: "Paid Days Off",
      shiftTime: "Shift Slots",
      payrollPerDay: "Payroll Per Day",
      paidTraining: "Paid Training",
      paidTrainingDetails: "Paid Training Details",
      trainingName: "Training Name",
      trainingDescription: "Training Description",
      trainingPaidAmount: "Paid Amount",
      trainingNumberOfDays: "Number Of Training Days",
      trainingStartDate: "Start Date & Time",
      trainingEndDate: "End Date & Time",
      trainingCheckInMargin: "Check-in Time Margin",
      trainingCheckOutMargin: "Check-out Time Margin",
      trainingLocation: "Training Location",
      locationBoundaries: "Location Boundaries (in meters)",
      trainingLocationBoundariesHelper:
        "Same as event by default. Can be edited.",
      paidTrainingDescription: "Enable paid training for this shift",
      deletePaidTrainingModalMessage:
        "Are you sure you want to delete the Paid Training?",
      duplicateTrainingFromShift: "Duplicate Training from another shift",
      selectShiftToDuplicateFrom: "Select shift to duplicate from:",
      shiftLabel: "Shift",
      trainingTimeConflictError: "Training times conflict with shift times",
      trainingTimeCopiedWarning:
        "The training time was copied from another shift. Please review and update it to match this shift.",
    },
    placeholders: {
      clientName: "Enter client name",
      eventName: "Enter Event Name",
      eventBrief: "Enter Event Brief",
      eventLocation: "Enter Event Location",
      diameter: "Enter Location Boundaries",
      eventType: "Enter Event Type",
      startBuildUpStart: "Buildup Start Date & Time",
      startBuildUpEnd: "Buildup End Date & Time",
      eventDayStart: "Event Start Date & Time",
      eventDayEnd: "Event End Date & Time",
      dismantlingDayStart: "Dismantling Start Date & Time",
      dismantlingDayEnd: "Dismantling End Date & Time",
      pmName: "Enter Project Manager Name",
      responsibility: "Enter Responsibility",
      nameOfRole: "Enter Role Name",
      numberOfMales: "Enter Number of Males",
      numberOfFemales: "Enter Number of Females",
      numberOfShifts: "Enter Number of Shifts",
      payrollAmount: "Enter Payroll Amount",
      workingHours: "Enter Working Time Slots",
      uniformCode: "Enter Uniform Code",
      timeToArriveToTheSite: "Enter Time to Arrive to The Site",
      zoneName: "Enter Zone Name",
      zoneManager: "Enter Zone Manager",
      email: "Enter Email",
      mobileNumber: "Enter Mobile Number",
      nameOfRequirement: "Enter Name of Requirement",
      quantity: "Enter Quantity",
      explanation: "Enter Explanation",
      enterYourComments: "Enter Enter your Comments",
      selectSupervisor: "Select Supervisor",
      checkinStart: "Before working time starts",
      checkinEnd: "After working time starts",
      checkoutStart: "Before working time ends",
      checkoutEnd: "After working time ends",
      numberOfDays: "Number of Days",
      paidDaysOff: "Paid Days Off",
      payrollPerDay: "Payroll Per Day",
      trainingName: "Enter Training Name",
      trainingDescription: "Enter Training Description",
      trainingPaidAmount: "Enter Paid Amount",
      trainingNumberOfDays: "Enter Number Of Training Days",
      trainingStartDate: "Select Start Date & Time",
      trainingEndDate: "Select End Date & Time",
      trainingCheckInMargin: "Enter Check-in Margin (minutes)",
      trainingCheckOutMargin: "Enter Check-out Margin (minutes)",
      trainingLocation: "Enter or select location on map",
      locationBoundaries: "Enter Location Boundaries",
      trainingLocationBoundariesPlaceholder:
        "Same as event by default (editable)",
    },
    singleDayEvent: "Single Day Event",
    daily: "Daily",
    monthly: "Monthly",
    public: "Public",
    private: "Private",
    add: "Add",
    continue: "Continue",
    saveContinue: "Save & Continue",
    saveLater: "Save & Complete Later",
    start: "Start",
    end: "End",
    save: "Save",
    saveAndPublish: "Save & publish",
    selectLocationOnMap: "Select location on map to publish event",
    addAtListOnePm: "Add at least one project manager to publish event",
    addAtListOneRole: "Add at least one Role to publish event",
    addSlot: "fill time slot to publish event",
    addAtListOneZone: "Add at least one zone to publish event",
    addAtListOneRequirement: "Add at least one requirement to publish event",
    addAtListOnePmEditMode: "Add at least one project manager",
    addAtListOneRoleEditMode: "Add at least one Role",
    addAtListOneZoneEditMode: "Add at least one zone",
    addAtListOneRequirementEditMode: "Add at least one requirement",
    noPhoneProvided: "No phone number provided for this employee",
    autoDeduction: "Automatic Deduction",
    shifts: {
      morning: "Morning",
      evening: "Evening",
      night: "Night",
      fullTime: "Full Time",
    },
  },
  listEvents: {
    listEventsBreadcrumb: "Events",
    eventType: "Event Type",
    eventId: "Event Id",
    eventName: "Event Name",
    owningCompany: "Owning Company",
    companyName: "Company Name",
    city: "City",
    locationVenue: "Location & Venue",
    staffingFill: "Staffing Fill",
    status: "Status",
    filter: "Filter",
    createEvent: "Create Event",
    notAvailable: "-",
    details: "'s details",
    startDate: "Start Date",
    endDate: "End Date",
    startEndDate: "Start/End Date",
    projectManager: "Project Manager",
    searchPlaceHolder: "Search Events",
    searchByNameOrId: "Search by event name or ID",
    showingEventsRange: "Showing {from}–{to} of {total} events",
    eventsColumn: "Events",
    eventIdPrefix: "ID",
    eventIdCaption: "Event ID:",
    projectManagers: "Project Managers",
    type: "Type",
    publishMode: "Publishing Mode",
    daily: "Daily",
    monthly: "Monthly",
    emptyAction: "Create Your First Event",
    emptyTitle: "No events found",
    noDataDescription:
      "You don't have any events currently running. Create a new event to start managing your operations.",
    eventTabs: {
      ongoing: "Ongoing",
      upcoming: "Upcoming",
      previous: "Completed",
      pending: "Pending",
      cancelled: "Cancelled",
    },
    eventStatus: {
      ongoing: "Ongoing",
      upcoming: "Upcoming",
      past: "Completed",
      pending: "Pending",
      canceled: "Cancelled",
    },
  },
  viewEvents: {
    eventId: "Event ID:",
    // Applicant-engagement figures (PROLINE-3866/3867), shown in the header
    // subtitle. Raw as returned by the API, no rounding.
    saudiApplicantsCount: "{count} Saudi Applicants",
    juniorApplicantsSuffix: "<5 events",
    location: "Location",
    eventLocation: "Event Location",
    city: "City",
    trainingLocation: "Location & Boundaries",
    diameter: "Location Boundaries",
    radiusFromCenter: "Radius from center point",
    meters: "meters",
    viewEventsBreadcrumb: "Event Details",
    deleteBtn: "Delete Event",
    cancelBtn: "Cancel Event",
    editBtn: "Edit Event",
    basicInfo: "Basic Info",
    notProvided: "Not Provided",
    eventType: "Event Type",
    publishingMode: "Publishing Mode",
    recurrency: "Recurrency",
    paidDaysOff: "Paid Days Off",
    public: "Public",
    private: "Private",
    projectManagers: "Project Managers",
    client: "Client",
    roles: "Roles",
    zones: "Zones",
    requirementsAndComments: "Requirements & Comments",
    add: "Add",
    edit: "Edit",
    noLocation: "No Location Selected yet",
    noImage: "No Image Selected yet",
    noProjectManagers: "No Project Managers Added",
    noClient: "No Client Added",
    noClientAssigned: "No Client Assigned",
    noClientAssignedDescription:
      "Assign a client to this event to manage billing and documentation.",
    clientEmail: "Client Email",
    clientPhone: "Client Phone",
    noRoles: "No Roles Added",
    noZones: "No Zones Added",
    emptyRolesTitle: "No roles added yet",
    emptyRolesDescription:
      "Define the roles your event needs to start organizing shifts and assigning applicants effectively.",
    addNewRole: "Add New Role",
    emptyZonesTitle: "No zones created yet",
    emptyZonesDescription:
      "Organize your event by adding the first zone to start managing staff and operations effectively across different locations.",
    addNewZone: "Add New Zone",
    workingShifts: "Working Shifts",
    shiftType: "Shift Type",
    totalPayroll: "Total Payroll",
    timeSlot: "Time Slot",
    uniformCode: "Uniform Code",
    checkInOutMargins: "Check-in / Out Margins",
    beforeStart: "Before Start",
    afterStart: "After Start",
    beforeEnd: "Before End",
    afterEnd: "After End",
    male: "Male",
    female: "Female",
    sar: "Sar",
    none: "None",
    noRequirements: "No Requirements Added",
    emptyRequirementsTitle: "No requirements added yet",
    emptyRequirementsDescription:
      "Define the physical materials, tools, and logistical needs required for each zone and role in this event.",
    eventRequirements: "Event Requirements",
    internalComments: "Internal Comments",
    requirementName: "Requirement Name",
    quantity: "Quantity",
    explanation: "Explanation",
    noComments: "No Comments Added",
    emptyCommentsTitle: "No comments added yet",
    emptyCommentsDescription:
      "Share internal notes and coordination updates with your team for this event.",
    managerInfo: "Manager Info",
    managerEmail: "Manager Email",
    managerPhone: "Manager Phone",
    supervisorInfo: "Supervisor Info",
    supervisorName: "Supervisor Name",
    applicants: "Applicants",
    evaluations: "Evaluations",
    timesheet: "Timesheet",
    reports: "Reports",
    clientReports: "Client Reports",
    payroll: "Payrolls",
    heatMap: "Heatmaps",
    heatmapTab: {
      selectZoneToMonitor: "Select Zone To Monitor",
      allZones: "All Zones",
      liveTrackingActive: "Live Tracking Active",
      supervisors: "Supervisors",
      organizers: "Organizers",
      inactive: "Inactive",
      offline: "Offline",
      clusterZoomHint: "Zoom out to cluster nearby Applicants · Zoom in to view them individually",
      clickMarkerHint: "Click any marker to view staff details",
      staffMembersGrouped: "{count} staff members",
      groupedHint: "Grouped in this area — zoom in to separate",
      zoomIn: "Zoom in",
      zoomOut: "Zoom out",
      mapLayers: "Map layers",
      fullscreen: "Fullscreen",
      close: "Close",
    },
    totalNumberOfApplicants: "Total Number of Applicants",
    viewApplicantsList: "View Applicants List",
    fullName: "Full Name",
    currentStatus: "Current Status",
    unassigned: "Unassigned",
    assigned: "Assigned",
    notAssignedYet: "Not assigned yet",
    staffingSummary: "Staffing Summary",
    totalApplicants: "Total Applicants",
    totalStaff: "Total Staff",
    applicantsTab: {
      supervisor: "Supervisor",
      others: "Other roles",
      status: "Status",
      gender: "Gender",
      zone: "Zone",
      role: "Role",
      name: "Name",
      email: "Email",
      note: "Note",
      shift: "Shift",
      nationality: "Nationality",
      city: "City",
      genderOptions: {
        male: "Male",
        female: "Female",
      },
      placeholders: {
        supervisor: "Search by supervisor name",
        others: "Search by applicant name, supervisor name",
        noData: "No applicants accepted yet",
        noSearchResults: "Sorry, no applicants found",
      },
      assign: "Assign",
      assigned: "Assigned",
      notAssigned: "Not Assigned",
      unassign: "Unassign",
      reallocate: "Reallocate",
      remove: "Remove",
      unassignApplicant: "Unassign applicant",
      reallocateApplicant: "Reallocate applicant to another zone",
      assignApplicant: "Assign applicant to zones",
      removeApplicant: "Remove applicant to zones",
      unassignConfirmationMsg:
        "Are you sure that you want to unassign this applicant from the zone?",
      removeConfirmationMsg:
        "Are you sure that you want to remove this applicant from the zone and event?",
      inviteMoreApplicants: "Invite applicants",
      inviteApplicants: "Invite applicants",
      invite: "Invite",
      searchByApplicant: "Search by applicant name",
      hint: "To change the role before inviting the applicant, edit the dropdown selection",
      selectFile: "Select Fields For Export CSV",
      export: "Export",
      exportAll: "Export All",
      clearSelection: "Clear Selection",
      timeConflict: "Time Conflict",
      selectAll: "Select All",
      trainingDays: "Training Days",
      trainingDailyAmount: "Training Daily Amount",
      trainingTotalAmount: "Training Total Amount",
      totalShiftAmount: "Total Shift Amount",
      joiningRequestsStatusTabs: {
        pending: "Pending",
        joined: "Joined",
        rejected: "Rejected",
        removed: "Removed",
      },
      joiningRequests: {
        searchPlaceholder: "Search by Name/ID",
        emptyStates: {
          pending: {
            title: "No Pending Requests",
            description:
              "All applicant requests have been reviewed. New requests will appear here.",
          },
          joined: {
            title: "No Joined Applicants",
            description:
              "There are no joined applicants yet. Approve pending requests to add applicants here.",
          },
          rejected: {
            title: "No Rejected Applicants",
            description:
              "There are no rejected applicants in this event yet. Rejected requests will appear here.",
          },
          removed: {
            title: "No Removed Applicants",
            description:
              "There are no removed applicants in this event yet. Removed applicants will appear here.",
          },
        },
        filteredEmptyState: {
          title: "No Results Found",
          description:
            "No applicants match your search or filter criteria. Try adjusting your search or filters.",
        },
        rangeTemplate: "Showing {from}-{to} of {total} applicants",
        rowsPerPageLabel: "Number Of Rows",
        selectedCount: "{count} Selected",
        workingHoursFilter: {
          label: "Working Hours",
          options: {
            less_than_250: "Less than 250",
            "250_to_450": "250 to 450",
            "450_to_850": "450 to 850",
            more_than_850: "More than 850",
          },
        },
        requestDateFilter: {
          from: "From Date",
          to: "To Date",
        },
        bulkActions: {
          approve: "Approve",
          reject: "Reject",
          accept: "Accept",
          cancel: "Cancel",
          unassign: "Unassign",
          reallocate: "Reallocate",
          allocate: "Allocate",
          export: "Export",
          editRole: "Edit Role",
          remove: "Remove",
          reactivate: "Reactivate",
          editReason: "Edit Reason",
          addEditTag: "Add/Edit tag",
          deleteTag: "Delete tag",
        },
        tagModal: {
          titleAdd: "Add Tag",
          titleEdit: "Edit Tag",
          hint: "Pick a Tag",
          selectTag: "Select Tag",
          save: "Save Tag",
          cancel: "Cancel",
          assignSkipInfo:
            "<b>{count} of {total} applicants</b> already have tags and will be skipped. The tag will only be applied to the remaining <b>{remaining} applicants.</b>",
          assignSuccess: "Tag saved for {count} applicants",
          allAlreadyTagged:
            "All {count} selected applicants already have tags assigned.",
        },
        deleteTagModal: {
          title: "Delete tag",
          deleteSingle: "You're about to remove this tag.",
          deleteMultiple: "You're about to remove tags from multiple applicants.",
          deleteQuestion: "Are you sure you want to continue?",
          cancel: "Cancel",
          deleteConfirm: "Delete",
          noneToDelete:
            "None of the {count} selected applicants have tags assigned. There is nothing to delete.",
          deleteUntaggedSkip:
            "{count} of applicants have no tags and will be skipped. Tags will only be removed from the remaining {remaining} applicants.",
          deleteOtherOwnerSkip:
            "{count} of applicants will be skipped. Tags will only be removed from the remaining {remaining} applicants.",
          deleteSuccess: "Tag deleted for {count} applicants",
        },
        approveModal: {
          title: "Approve Request",
          editRoleTitle: "Edit Role",
          requestedRole: "Requested Role",
          singleMessage:
            "This action requires your attention. Please review the details before proceeding.",
          bulkMessage: "You are about to approve {count} selected applicants.",
          editRoleBulkMessage:
            "You are about to edit role for {count} selected applicants.",
          singleHint:
            "This action requires your attention. Please review the details before proceeding.",
          bulkHint: "This action will apply to all selected applicants.",
          editRoleHint:
            "Select the new role and shift for the selected applicants.",
          currentRole: "Approve with current role",
            changeRole: "Change role before approving",
            newRole: "New Role",
            newShift: "New Shift",
            selectRole: "Select Role",
            selectShift: "Select Shift",
            shiftTemplate: "--{shift}--",
            bulkRoleChangeTo: "Role: {role}",
            bulkShiftChangeTo: "Shift: {shift}",
            changeSummaryDescription:
              "Applicants will be notified of the role & shift changes.",
            cancel: "Cancel",
          approve: "Approve",
          saveRole: "Save",
        },
        changeRoleModal: {
          title: "Change Role",
          singleMessage: "Update the role and shift for this applicant",
          bulkMessage:
            "You are about to change roles for {count} applicants to one role and shift",
          mixedMessage:
            "Your selection includes regular applicants and supervisors",
          selectedTemplate: "{count} applicants selected",
          mixOfRolesAndShifts: "Mix of Roles and Shifts",
          newRole: "New Role",
          newShift: "New Shift",
          selectRole: "Select Role",
          selectShift: "Select Shift",
          overrideTitle: "This will override all selected applicants",
          overrideSupervisorTitle:
            "This action will override all selected applicants, including the supervisor.",
          overrideDescription:
            "The new role and shift will replace the existing ones for all {count} applicants.",
          demotionTitle: "Changing this role will demote this supervisor",
          singleDemotionDescription:
            "{name} is a supervisor assigned to {zone}. Changing their role will:",
          singleUnassignedDemotionDescription:
            "{name} is a supervisor. Changing their role will:",
          bulkDemotionWarning:
            "Changing this role will demote The selected supervisor/s, You'll need to assign new supervisor/s to their zone/s",
          removeSupervisorStatus: "Remove their supervisor status",
          unassignZones: "Unassign them from {zone}",
          zonesNeedSupervisor:
            "{zone} will have no supervisor until reassigned",
          notifyApplicants: "Notify applicants whose jobs have changed",
          cancel: "Cancel",
          confirm: "Confirm",
        },
        allocateModal: {
          title: "Allocate",
          confirmTitle: "Confirm allocation",
          singleMessage: "You are about to allocate this applicant to a zone",
          bulkMessage: "You are about to allocate {count} applicants to one zone",
          mixedSelectionMessage:
            "Your selection includes regular applicants and supervisors. Only regular applicants will be allocated below.",
          selectedTemplate: "{count} applicants selected",
          selectedRegularTemplate: "{count} regular applicants selected",
          selectedRegularSingularTemplate: "{count} regular applicant selected",
          mixedAssignment: "Mix of assigned and unassigned staff",
          allAllocatedTemplate: "All {count} applicants will be allocated here",
          breakdownTemplate: "{unassigned} unassigned / {assigned} reallocated",
          assignedStatus: "Currently assigned",
          unassignedStatus: "Currently unassigned",
          zone: "Zone",
          selectZone: "Select Zone",
          supervisor: "Supervisor",
          supervisorsNoAction: "{count} supervisors: No action",
          supervisorsHintPrefix: "Use the ",
          supervisorsHintEmphasis: "Zones",
          supervisorsHintSuffix: " tab to allocate them",
          zonesTab: "Zones tab",
          back: "Back",
          cancel: "Cancel",
          approve: "Approve",
        },
        unassignModal: {
          confirmTitle: "Confirm un-assignment",
          supervisorTitle: "Supervisor(s) Selected",
          singleQuestion:
            '"Are you sure you want to unassign this applicant from their zone?"',
          bulkQuestion:
            '"Are you sure you want to unassign {count} applicants from their zones?"',
          supervisorBody:
            "Your selection of {count} applicants includes {supervisors} Supervisor(s). Unassigning them will leave their assigned zones without leadership. Are you sure you want to proceed with unassigning all selected applicants?",
          clearZoneHint:
            "This will clear their zone and set allocation to Unassigned.",
          bulkSummary:
            "({assigned}) Will be unassigned - ({unassigned}) Already unassigned Will be skipped",
          zoneWillBeCleared: "Zone will be cleared",
          statusChange: "Allocation status : Assigned → Unassigned",
          nothingTitle: "Nothing to unassign",
          nothingBody: "All selected applicants are already unassigned.",
          nothingDetails:
            "All {count} selected applicants have no zone assigned. There is nothing to unassign. No changes will be made.",
          assignedStatus: "Currently assigned",
          supervisor: "Supervisor",
          cancel: "Cancel",
          unassign: "Unassign",
          ok: "OK, got it",
        },
        removeModal: {
          title: "Confirm Removal",
          singleQuestion:
            "Are you sure you want to remove this applicant from this event?",
          bulkQuestion:
            "Are you sure you want to remove {count} applicants from this event?",
          singleSupervisorTitle: "This applicant is a supervisor",
          singleSupervisorDescription:
            "Removing him will leave {zone} without a supervisor.",
          singleUnassignedSupervisorDescription:
            "Removing him will leave the event without this supervisor.",
          bulkSupervisorTitle: "{count} supervisors included",
          bulkSupervisorDescription:
            "Their Zones will left without Supervisors",
          reasonLabel: "Removal Reason",
          reasonRequired: "Removal Reason is required",
          placeholder: "Enter removal reason",
          cancel: "Cancel",
          remove: "Remove",
        },
        reactivateModal: {
          singleTitle: "Reactivate Applicant?",
          bulkTitle: "Reactivate Applicants?",
          singleMessageBefore: "Are you sure you want to reactivate ",
          singleMessageAfter:
            "? They will be moved back to their previous status.",
          bulkMessage:
            "Are you sure you want to reactivate {count} selected applicants to this event? They will be moved back to their previous status.",
          cancel: "Cancel",
          confirm: "Reactivate",
          successTitle: "Applicant has been reactivated",
          successBody:
            "Applicant has been moved back to the Joined applicants list.",
          bulkSuccessTitle: "Applicants have been reactivated",
          bulkSuccessBody:
            "Selected applicants have been moved back to the Joined applicants list.",
        },
        editRemovalReasonModal: {
          title: "Edit Removal Reason",
          singleMessage: "Update the removal reason for this applicant.",
          bulkMessage:
            "Update the removal reason for {count} selected applicants.",
          requestedRole: "Requested Role",
          reasonLabel: "Removal Reason",
          reasonRequired: "Removal Reason is required",
          placeholder: "Enter removal reason",
          cancel: "Cancel",
          save: "Save",
        },
        rejectModal: {
          title: "Confirm Rejection",
          bulkMessage: "You are about to Reject {count} selected applicants.",
          hint:
            "This action requires your attention. Please review the details before proceeding.",
          reasonLabel: "Rejection Reason",
          placeholder: "Enter your reason here...",
          cancel: "Cancel",
          reject: "Reject",
        },
        allocationStatusFilter: {
          placeholder: "Allocation Status",
          options: {
            assigned: "Assigned",
            notAssigned: "Not Assigned",
          },
        },
        applicantTypeFilter: {
          placeholder: "Applicant Type",
          options: {
            loyal: "Loyal Applicants",
            other: "Other Applicants",
          },
          emptyState: {
            loyal: {
              title: "No Loyal Applicants",
              description:
                "No applicants found matching this filter in the current stage.",
            },
            other: {
              title: "No Other Applicants",
              description:
                "No applicants found matching this filter in the current stage.",
            },
          },
        },
      },
      joiningRequestsTable: {
        id: "ID",
        staffApplicant: "Staff / Applicant",
        nationality: "Nationality",
        zone: "Zone",
        role: "Role",
        requestedRole: "Requested Role",
        requestDate: "Request Date",
        removedDate: "Removed Date",
        removeReason: "Remove Reason",
        shift: "Shift",
        checkIn: "Check-in",
        checkedIn: "Checked-in",
        nonCheckedIn: "Not Checked-in",
        workingHours: "Working Hours",
        rating: "Rating",
        tags: "Tags",
        addTag: "Add Tag",
        workingHoursUnit: "Hr",
      },
      joinedApplicantsSummary: {
        checkedIn: "Checked-in",
        notCheckedIn: "Not Checked-in",
        exportAll: "Export All",
        loyalApplicants: "Loyal Applicants",
        otherApplicants: "Other Applicants",
      },
    },
    payrollTab: {
      autoDeduction: "Auto-Deduction",
      lateCheckIn: "Late check-in",
      autoCheckout: "Auto check-out",
      payFullShift: {
        label: "Pay Full Scheduled Shift",
        tooltip:
          "Controls whether the actual check-out time is factored into the payroll calculation. When on, work hours are based on the full scheduled shift. Applies to daily events only.",
      },
      summary: {
        paidPayment: "Paid payment",
        pendingPayment: "Pending Payment",
      },
      searchPlaceholder: "Search by Applicant's name, ID...",
      giveAllRewards: "Give All Users Rewards",
      generateAllPayroll: "View All Applicants Payroll",
      selectedCount: "{count} selected",
      rowsPerPageLabel: "Number Of Rows",
      rangeTemplate: "Showing {from}-{to} of {total} applicants",
      addProof: "Add Proof",
      columns: {
        id: "ID",
        staff: "Staff/Applicant",
        role: "Current Role",
        nationality: "Nationality",
        finalPayroll: "Final Payroll",
        paymentStatus: "Payment Status",
        paymentProof: "Payment Proof",
      },
      paymentStatuses: {
        pending: "Pending",
        paid: "Paid",
      },
      filters: {
        gender: "Gender",
        role: "Role",
        nationality: "Nationality",
        removedStatus: "Applicant's Status",
        rewardType: "Adjustment",
        paymentStatus: "Payment Status",
        assigned: "Assigned",
        removed: "Removed",
        reward: "Has Reward",
        dedication: "Has Deduction",
      },
      bulkActions: {
        attachAndMarkPaid: "Attach & Mark as Paid",
        generatePayroll: "View Payroll Report",
        giveReward: "Give Reward",
        manualDeduction: "Manual Deduction",
      },
      attachMarkPaid: {
        title: "Upload Proof of Transaction",
        subtitleSingle: "Upload Proof of Transaction for {name}",
        subtitleBulk: "Upload Proof of Transaction for {count} applicants",
        markAsPaid: "Mark as Paid",
        clickToUpload: "Click to upload",
        dragHint: "or drag and drop",
        hint: "PNG, JPG or PDF — max 10MB (one file).",
        fileRequired: "Proof of transaction is required",
        invalidType:
          "Invalid file type. Only PNG, JPG, or PDF files are accepted.",
        invalidSize: "File size exceeds 10MB. Please upload a smaller file.",
        uploadFailed: "Upload failed. Try again",
      },
      viewProof: {
        title: "Proof of Transaction",
        readyToUpload: "Ready to upload",
        readyMeta: "Ready to upload • {size}",
      },
      manualAdjustment: {
        amountLabel: "Amount ({currency})",
        chooseReason: "Choose reason",
        validation: {
          amountRequired: "Amount must be greater than 0",
          reasonRequired: "Reason is required",
          reasonsLoadFailed: "Reasons failed to load. Please try again.",
        },
        reward: {
          title: "Add Reward",
          reasonLabel: "Reason for Reward",
          apply: "Apply Reward",
          subtitleSingle: "Applying reward for {name}",
          subtitleBulk: "This reward will apply to {count} applicants",
          subtitleAll: "This reward will apply to all applicants",
          successSingle: "The reward has been applied successfully",
          successBulk: "Reward applied to {count} applicants successfully",
          successPartial:
            "Reward applied to some applicants; others could not be processed.",
        },
        deduction: {
          title: "Manual Deduction",
          reasonLabel: "Reason for Deduction",
          apply: "Apply Deduction",
          subtitleSingle: "Applying deduction for {name}",
          subtitleBulk: "This deduction will apply to {count} applicants",
          successSingle: "The deduction has been applied successfully",
          successBulk: "Deduction applied to {count} applicants successfully",
          successPartial:
            "Deduction applied to some applicants; others could not be processed.",
        },
        rowActions: {
          generatePayroll: "Generate Payroll",
          giveReward: "Give Reward",
          manualDeduction: "Manual Deduction",
          ariaLabel: "Payroll actions",
        },
      },
      generatePayroll: {
        singleTitle: "Applicant Payroll",
        singleSubtitle: "Full pay breakdown for this applicant's work period.",
        bulkTitle: "Payroll Report",
        bulkSubtitle: "Review and export payroll for {count} applicants.",
        applicantDetails: "Applicant Details",
        staffName: "Staff Name",
        reportPeriod: "Report Period",
        startDate: "Start Date",
        endDate: "End Date",
        endDateBeforeStartDate: "End date can't be before start date",
        stcNo: "STC No.",
        loading: "Loading payroll report",
        summary: {
          baseEarnings: "Base Earnings",
          deductions: "Deductions",
          rewards: "Rewards",
          training: "Training",
          finalNetPay: "Final Net Pay",
          totalDeductions: "Total Deductions",
          totalRewards: "Total Rewards",
          totalNetPay: "Total Net Pay",
          currency: "SAR",
        },
        sections: {
          baseEarnings: "Base Earnings",
          training: "Training",
          deductions: "Deductions",
          rewards: "Rewards",
          autoDeductionReason: "Automatic deduction",
          baseEarningsMeta: "{roles} roles - {days} days total",
          trainingMeta: "{roles} roles - {days} days total",
          deductionsMeta: "{count} entries",
          rewardsMeta: "{count} entries",
          roleRank: "{rank} role",
          days: "{count} Days",
          ratePerDay: "{amount}/Days",
          add: "Add entry",
          typeAuto: "Auto",
          typeManual: "Manual",
          systemTag: "System",
          revertEntry: "Revert entry",
          addDeduction: "Add Deduction",
          addReward: "Add Reward",
          baseEarningsEmptyTitle: "No shifts worked",
          baseEarningsEmptyDescription:
            "No attendance was recorded in this period.",
          trainingEmptyTitle: "No training shifts",
          trainingEmptyDescription:
            "No training was recorded in this period.",
          deductionsEmptyDescription:
            "No deduction applied for this period.",
          rewardsEmptyDescription: "No rewards applied for this period.",
        },
        columns: {
          id: "ID",
          staff: "Staff/Applicant",
          days: "Days",
          shiftPay: "Shift Pay",
          autoDeduction: "Auto Deduction",
          manualDeduction: "Manual Deduction",
          rewards: "Rewards",
          trainingDays: "Training Days",
          trainingPay: "Training Pay",
          totalAmount: "Total Amount",
          stcNo: "STC No.",
          roleCount: {
            one: "{count} Role",
            other: "{count} Roles",
          },
        },
        rangeTemplate: "Showing {from}-{to} of {total} applicants",
        shifts: {
          fulltime: "Fulltime",
          morning: "Morning",
          afternoon: "Evening",
          night: "Night",
        },
        rolesLegend: "Roles",
        trainingsLegend: "Trainings",
        ratePerDayLegend: "{role} {amount}/Day",
        actions: {
          back: "Back",
          exportReport: "Export Report",
          revertDeduction: "Revert Deduction",
          revertReward: "Revert Reward",
        },
        footer: {
          single: "Reviewing payroll for this applicant",
          bulk: "Generating payroll for {count} applicants.",
        },
        toast: {
          exportReport: "Payroll report exported.",
          revertDeduction: "Manual deductions reverted.",
          revertReward: "Rewards reverted.",
          revertDeductionEntry: "Deduction has been reverted successfully.",
          revertRewardEntry: "Reward has been reverted successfully.",
          addDeduction: "Deduction has been added successfully.",
          addReward: "Reward has been added successfully.",
        },
        revertConfirm: {
          deductionAllTitle: "Revert all deductions?",
          deductionAllDescription:
            "This will remove all manually added deduction entries for this applicant. This action cannot be undone.",
          deductionAllWarning:"Auto-applied deductions will remain.",
          deductionAllWarningDescription: "This action only reverts manually added deductions.",
          deductionAllConfirm: "Yes, Revert Deduction",
          deductionSingleTitle: "Revert This Deduction?",
          deductionSingleDescription:
            "This will remove this deduction entry for this applicant.",
          deductionSingleConfirm: "Yes, Revert Deduction",
          rewardAllTitle: "Revert all rewards?",
          rewardAllDescription:
            "This will remove all reward entries for this applicant and set the reward total to 0. This action cannot be undone.",
          rewardAllConfirm: "Yes, Revert Rewards",
          rewardSingleTitle: "Revert This reward?",
          rewardSingleDescription:
            "This will remove this reward entry for this applicant.",
          rewardSingleConfirm: "Yes, Revert Reward",
        },
      },
      emptyStates: {
        event: {
          title: "No payroll records yet",
          description:
            "Payroll data will appear here once staff have completed shifts for this event.",
        },
        filtered: {
          title: "No Results Found",
          description:
            "No payroll records match your search or filter criteria. Try adjusting your search or filters.",
        },
      },
      toast: {
        giveAllRewards: "Reward has been applied to all approved applicants.",
        generateAllPayroll: "Payroll generation started for all users.",
        attachAndMarkPaid: "Selected applicants marked as paid.",
        generatePayroll: "Payroll generated for selected applicants.",
        giveReward: "Reward applied to selected applicants.",
        manualDeduction: "Manual deduction applied to selected applicants.",
        addProof: "Payment proof uploaded.",
        autoDeduction:
          "Automatic deduction settings updated. Existing deductions are unchanged — this applies to future actions only.",
        payFullShift: "Payroll calculation setting updated.",
      },
    },
    timesheetTab: {
      searchPlaceholder: "Search by Name or ID",
      exportAll: "Export All",
      exportModal: {
        title: "Export report to csv",
        description:
          "Choose the fields to include in your CSV file. At least one field must be selected.",
        selectAll: "Select all fields",
        confirmExport: "Confirm Export",
        successTitle: "Report Exported",
        successMessage:
          "Your CSV file is ready. The download should start automatically.",
        errorTitle: "Export Failed",
        errorMessage:
          "The report could not be generated. Please try again or contact support if the issue persists.",
      },
      applicantName: "Applicant Name",
      workingDays: "Working Days",
      workingHours: "Working Hours",
      trainingDays: "Training Days",
      status: "Status",
      applicantRole: "Applicant Role",
      applicantStatus: "Applicant Status",
      startDate: "Start Date",
      endDate: "End Date",
      shift: "Shift",
      workingHoursPerDay: "Working Hours/Day",
      shiftsTab: "Shifts",
      trainingsTab: "Trainings",
      statuses: {
        approved: "Approved",
        removed: "Removed",
        cancelled: "Cancelled",
      },
      emptyStates: {
        event: {
          title: "No Timesheet Data Available",
          description:
            "Applicants' timesheet and working slots will appear here once shifts have started",
        },
        shifts: {
          title: "No Shifts Logged Yet",
          description:
            "No shifts have been recorded for this applicant. Added slots will appear here.",
        },
        trainings: {
          title: "No Trainings Logged Yet",
          description:
            "No training sessions have been recorded for this applicant. Added sessions will appear here.",
        },
        filtered: {
          title: "No Results Found",
          description:
            "No timesheet records match your search or filter criteria. Try adjusting your search or filters.",
        },
      },
      rangeTemplate: "Showing {from}-{to} of {total} applicants",
      rowsPerPageLabel: "Number Of Rows",
      addSlotModal: {
        shiftTitle: "Add Shift Slot",
        trainingTitle: "Add Training Slot",
        editShiftTitle: "Edit Shift Slot",
        editTrainingTitle: "Edit Training Slot",
        subtitle: "Add slot for {name}",
        editSubtitle: "Edit slot for {name}",
        checkInDate: "Check-in Date",
        checkInTime: "Check-in Time",
        checkOutDate: "Check-Out Date",
        checkOutTime: "Check-Out Time",
        saveChanges: "Save Changes",
        failureTitle: "Slot Could Not Be Added",
        failureMessage:
          "Something went wrong. Please check the slot details and try again.",
      },
      deleteSlotModal: {
        shiftTitle: "Delete Shift Slot",
        trainingTitle: "Delete Training Slot",
        confirmationMessage:
          "Are you sure you want to delete this report?\nThis action cannot be undone.",
        date: "Date",
        checkIn: "Check-In",
        checkOut: "Check-out",
        workingHours: "Working Hours",
        checkoutType: "Checkout Type",
        warning:
          "Deleting this slot will update this applicant's working hours and expected payroll.",
        deleteSlot: "Delete Slot",
      },
    },
    sending: "Sending",
    sendNotification: "Send Notification",
    messageRequired: "Message is Required",
    pushNotification: "Push Notification",
    sendPushNotification: "Send Push Notification",
    notificationSend: "Notification has been sent",
    enterPushNotification: "Enter Push Notification Message",
    cancelModalConfirmMessage: "Are you sure you want to cancel this event?",
    submitEventPushNotification:
      "Are you sure you want to send the notification?",
    deleteModalConfirmMessage:
      "Deleted event cannot be retrieved , Are you sure you want to delete this event?",
    completedEvaluationBtn: "Start Evaluation Round",
    startEvaluationRound:
      "Are you sure that you want to start an evaluation round for",
    disbaledCreateEvaluationBtnHint:
      "Button is disabled because dismantling days have started",
    checkedinApplicants: "Checked-in Applicants",
    noncheckedinApplicants: "Not Checked-in Applicants",
    checkinStatus: "Check-in Status",
    checkedIn: "Checked-in",
    nonCheckedIn: "Not checked-in",
    paidTraining: {
      sectionTitle: "View Paid Training Details",
      trainingName: "Training Name",
      trainingDescription: "Training Description",
      trainingStart: "Training Start Date & Time",
      trainingEnd: "Training End Date & Time",
      checkInMargin: "Training Check-in Margin",
      checkInBeforeMargin: "Before training starts (minutes)",
      checkInAfterMargin: "After training starts (minutes)",
      checkOutMargin: "Training Check-out Margin",
      checkOutBeforeMargin: "Before training ends (minutes)",
      checkOutAfterMargin: "After training ends (minutes)",
      numberOfDays: "Number of Training Days",
      payrollAmount: "Training Payroll Amount",
      payrollPerDay: "Training Payroll Per Day",
      location: "Training Location",
      locationBoundaries: "Location Boundaries",
      trainingAttendanceQrCode: "Training Attendance QR Code",
      print: "Print",
    },
    evaluationsTab: {
      subTabs: {
        applicants: "Applicants Evaluations",
        company: "Company Evaluations",
      },
      searchPlaceholder: "Search by round number",
      filterStatus: "Status",
      filterStartDate: "Start Date",
      filterEndDate: "End Date",
      runningIndicator: "{name} is Running",
      startEvaluationRound: "Start Evaluation Round",
      companyTab: {
        emptyTitle: "No evaluation rounds yet",
        emptyDescription: "Start your first round to begin assessing applicants",
        pendingTitle: "No evaluation submitted yet",
        pendingDescription: "The client hasn't submitted their satisfaction survey for this event yet.",
        overallSatisfaction: "Over All Satisfaction",
        evaluationStatus: "Evaluation Status",
        statusCompleted: "Completed",
        statusPending: "Pending",
        suggestionsFeedback: "Suggestions / Feedback",
        noFeedback: "No feedback provided.",
        criteriaGroups: {
          serviceAndQuality: "Service & Quality",
          reliabilityAndSupport: "Reliability & Support",
          financialAndAdmin: "Financial & Admin",
        },
        criteria: {
          serviceQuality: "Service quality",
          attentionToDetail: "Attention to detail",
          understandingRequests: "Understanding requests",
          speedOfResponse: "Speed of response",
          complaintResolutionSpeed: "Complaint resolution speed",
          wayOfResolvingComplaints: "Way of resolving complaints",
          compliance: "Compliance",
          adminFinanceCooperation: "Admin/Finance cooperation",
          priceTermsOfPayments: "Price/terms of payments",
        },
      },
      satisfactionSurveyForm: {
        title: "Satisfaction Survey",
        subtitle: "Share your feedback on the company's performance for this event.",
        clickToRate: "Click Stars To Rate",
        feedbackPlaceholder: "Enter your suggestions or feedback here ...",
        evaluationStatus: "Evaluation Status",
        statusInProgress: "In progress",
        cancel: "Cancel",
        submit: "Submit Evaluation",
        submitSuccess: "Your satisfaction survey has been submitted.",
      },
      rangeTemplate: "Showing {from}-{to} of {total} rounds",
      rowsPerPageLabel: "Number Of Rows",
      table: {
        round: "Round",
        applicantsNo: "Applicants No.",
        startDate: "Start Date",
        endDate: "End Date",
        status: "Status",
        progress: "Progress",
        emptyTitle: "No Evaluation Rounds",
        emptyDescription: "No evaluation rounds have been created for this event yet.",
        noResultsTitle: "No Matching Rounds",
        noResultsDescription: "No evaluation rounds match your search or filters.",
        statuses: {
          running: "Running",
          completed: "Completed",
        },
      },
      runningButtonLabel: "Evaluation Round is Running",
      runningTooltip: "The Evaluation Round will be Running Until Evaluate all applicants.",
      startRoundModal: {
        title: "Start Evaluation Round",
        message: "This will begin a new evaluation round for all applicants in this event. Evaluators will be able to submit scores immediately after.",
        cancel: "Cancel",
        confirm: "Start Round",
      },
      applicantsView: {
        backToRounds: "Back to Rounds",
        searchPlaceholder: "Search by name or role",
        filterZone: "Zone",
        filterRole: "Role",
        filterStatus: "Status",
        runningIndicator: "{name} is Running",
        rangeTemplate: "Showing {from}-{to} of {total} applicants",
        rowsPerPageLabel: "Number Of Rows",
        table: {
          applicantName: "Applicant Name",
          role: "Role",
          zoneName: "Zone Name",
          evaluationDate: "Evaluation Date",
          status: "Status",
          actions: "Actions",
          viewResult: "View Result",
          evaluate: "Evaluate",
          emptyTitle: "No Applicants",
          emptyDescription: "No applicants found for this evaluation round.",
          noResultsTitle: "No Matching Applicants",
          noResultsDescription: "No applicants match your search or filters.",
          statuses: {
            pending: "Pending",
            done: "Done",
          },
        },
        viewResultForm: {
          overallSatisfaction: "Over All Satisfaction",
          statusCompleted: "Completed",
          statusInProgress: "In progress",
          allRoundsSummary: "All Rounds Summary",
          average: "Average",
          noFeedback: "No feedback provided.",
          editEvaluation: "Edit Evaluation",
          clickToReRate: "Click Stars To Re-rate",
          saveChanges: "Save Changes",
          cancel: "Cancel",
          saveSuccess: "Evaluation changes have been saved successfully.",
        },
        evaluateForm: {
          title: "Applicants Evaluations",
          subtitle: "Reviewing performance for the {roundName} Evaluation Round.",
          applicantDetails: "Applicant Details",
          staffName: "Staff Name",
          role: "Role",
          assignedZone: "Assigned Zone",
          performanceIndicators: "Performance Indicators",
          clickToRate: "Click Stars To Rate",
          criteria: {
            wellPresentable: "Well Presentable",
            interactionWithPeople: "Interaction With People",
            punctuality: "Punctuality",
            behavioralAttitude: "Behavioral Attitude",
            performance: "Performance",
            followWorkRegulation: "Follow Work Regulation",
          },
          detailedFeedback: "Detailed Feedback",
          feedbackPlaceholder: "Enter your performance feedback here ...",
          evaluationStatus: "Evaluation Status",
          statusInProgress: "In progress",
          cancel: "Cancel",
          submit: "Submit Evaluation",
        },
      },
    },
  },
  editEvents: {
    editEventBreadcrumb: "Edit Event",
    /** {status} = localized tab label (e.g. Previous, Cancelled) from listEvents.eventTabs */
    readOnlyEventCannotEditStatus:
      "This event cannot be edited because it is {status}.",
    /**
     * Shown in the confirmation modal when the new event dates overlap an ongoing
     * event that shares approved applicants. The backend message (if any) is used
     * first; these serve as a fallback.
     */
    conflictModalTitle: "Date Overlap — Applicants Will Be Cancelled",
    conflictModalMessage:
      "The new dates overlap with an ongoing event that has shared approved applicants. Those applicants will be auto-cancelled if you proceed. Do you want to continue?",
  },
  exportApplicants: {
    subtitle: "Select the fields you want to include in your file.",
    confirmExport: "Confirm Export",
    autoDeductionAmount: "Auto Deduction Amount",
    manualDeductionAmount: "Manual Deduction Amount",
    manualDeductionReason: "Manual Deduction Reason",
    rewardAmount: "Reward Amount",
    rewardReason: "Reward Reason",
    trainingDays: "Training Days",
    numberOfTrainingDays: "Number of Training Days",
    trainingDailyAmount: "Training Daily Amount",
    trainingTotalAmount: "Training Total Amount",
    totalShiftAmount: "Total Shift Amount",
    checkInStatus: "Check-in Status",
    checkInTime: "Check-in Time",
    checkOutTime: "Check-out Time",
    dailyAmount: "Daily amount",
    date: "Date",
    email: "Email",
    gender: "Gender",
    id: "Id",
    imageUrl: "Image Url",
    name: "Name",
    note: "Note",
    numberOfWorkingDays: "Number of Working Days",
    phoneNumber: "Phone Number",
    role: "Role",
    status: "Status",
    allocationStatus: "Allocation Status",
    stcNumber: "Stc Number",
    nationalId: "National Id",
    supervisor: "Supervisor",
    totalAmount: "Total Amount (Training + Shift)",
    zone: "Zone",
    image: "Image",
  },
};

export default events;
